<template>
  <modal v-model="showModal">
    <template #body>
      <div class="w-4/5 p-4">
        <div class="card-panel relative p-4">
          <div class="text-cdp-black-500">
            <h3 v-if="type" class="mb-5 text-2xl">
              {{ t('edit') }}
              {{ t(`asset.${type}`) }}
            </h3>

            <button type="reset" class="modal-close" @click="toggleModal(false)">
              <icon name="ic_common_close" class="h-5 w-5" />
            </button>

            <div
              class="border-0.5 relative max-h-[70vh] w-full overflow-y-auto rounded-md"
            >
              <filter-tag
                v-if="type === 'filtration'"
                :uuid="uuid"
                @change="getEditData"
              />

              <edm-edit
                v-if="type === 'edm'"
                ref="edm"
                v-model="edmInstance"
                :uuid="uuid"
                :keyword="emailKeywords"
                @change="getEditData"
              />

              <sms-edit
                v-if="type === 'sms'"
                ref="sms"
                v-model:is-send-preview="isSendPreview"
                :uuid="uuid"
                :keyword="smsKeywords"
                @change="getEditData"
              >
                <template #footer>
                  <button
                    class="btn disabled-btn bg-cdp-yellow-400 text-cdp-white hover:bg-cdp-yellow-500"
                    @click="saveAsset(), (isSendPreview = true)"
                  >
                    {{ t('campaign_asset_set.send_preview_sms') }}
                  </button>
                </template>
              </sms-edit>
            </div>
          </div>
          <div class="mt-4 flex justify-end gap-3">
            <button
              class="btn flex items-center border border-cdp-main-primary bg-cdp-main-primary-light text-cdp-main-primary hover:bg-cdp-primary-200"
              @click="toggleModal(false)"
            >
              {{ t('cancel') }}
            </button>
            <button
              class="btn disabled-btn bg-cdp-main-primary text-cdp-white hover:bg-cdp-main-primary-dark"
              @click="toSaveAsset"
            >
              {{ t('save') }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { useI18n } from 'vue-i18n';
import modal from '@/components/Modal.vue';

import { storeToRefs } from 'pinia';
import { assetStore } from '@/stores/asset.js';

import edmEdit from './_EdmEdit.vue';
import smsEdit from './_SmsEdit.vue';
import filterTag from './_FilterTag.vue';

import { ref, defineComponent, watch } from 'vue';
export default defineComponent({
  name: 'ComponentsAssetModal',
  components: {
    modal,
    smsEdit,
    edmEdit,
    filterTag
  },
  setup() {
    const { t } = useI18n();

    const storeAsset = assetStore();
    const { toggleModal, setData, save } = storeAsset;

    const { data, type, uuid, emailKeywords, smsKeywords, showModal } =
      storeToRefs(storeAsset);

    const sms = ref(null);
    const edm = ref(null);
    const edmInstance = ref(null);
    const isSendPreview = ref(false);

    function getEditData(data) {
      setData(data);
    }

    async function toSaveAsset() {
      if (type.value === 'filtration') {
        await saveAsset();
        toggleModal(false);
      } else {
        let validate = false;
        switch (type.value) {
          case 'edm':
            validate = await edm.value.validate();
            if (validate.valid) {
              const waitForEdmUpdated = () =>
                new Promise((resolve) => {
                  edmInstance.value?.save();
                  watch(
                    () => data,
                    (value) => {
                      resolve(value);
                    }
                  );
                });
              await waitForEdmUpdated();
            }
            break;
          case 'sms':
            validate = await sms.value.validate();
            break;
        }
        if (validate.valid) {
          await saveAsset();
          toggleModal(false);
        }
      }
    }

    async function saveAsset() {
      await save({
        type: type.value,
        uuid: uuid.value,
        data: data.value
      });
    }

    return {
      t,
      type,
      uuid,
      emailKeywords,
      smsKeywords,
      showModal,
      edm,
      edmInstance,
      sms,
      isSendPreview,
      toggleModal,
      getEditData,
      toSaveAsset,
      saveAsset
    };
  }
});
</script>